import React from 'react';

function KeyHoldingServicesDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">Key Holding Services UK</h1>
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Our key holding services in the UK ensure that your property is secure and accessible at all times. We hold a set of your keys securely and respond quickly to any incidents, providing peace of mind and reliable security.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>24/7 Key Holding</li>
          <li>Emergency Response</li>
          <li>Alarm Response</li>
          <li>Property Inspections</li>
          <li>Access Management</li>
          <li>Secure Storage of Keys</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our professional key holding team in the UK is committed to providing secure and efficient services. We ensure the safety of your keys and property, using the latest security measures and adhering to all regulations.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our key holding services in the UK, please contact us at <a href="tel:07460395006" className="text-yellow-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-yellow-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default KeyHoldingServicesDetails;
